// DrugLicenseRegistration.jsx
import React from "react";

export default function DrugLicenseRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Drug License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Drug License Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides expert assistance for Drug License
            registration, helping pharmacies, wholesalers, and manufacturers
            comply with the Drugs and Cosmetics Act and applicable state drug
            control regulations.
          </p>
          <p className="text-gray-700">
            From identifying the appropriate category of license to preparing
            documentation and supporting inspections, the process is managed in
            a structured way so your premises and operations meet licensing
            standards.
          </p>
        </div>

        {/* Right: Image (new URL, square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3683055/pexels-photo-3683055.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Pharmacist working with medicines and prescriptions"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Drug License Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists in compiling and organizing the core
              information and proofs required by state drug authorities for
              granting a drug license.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  PAN and identity proof of the applicant / proprietor /
                  partners / directors (as applicable).
                </li>
                <li>
                  Premises address proof such as rent or lease agreement or
                  ownership documents, along with a recent utility bill.
                </li>
                <li>
                  Qualification certificates and registration details of the
                  competent person / pharmacist in charge.
                </li>
                <li>
                  Appointment letter of the competent person and an affidavit or
                  declaration as required by the licensing authority.
                </li>
                <li>
                  Layout / blueprint of the premises showing area and storage
                  arrangements, where required.
                </li>
                <li>
                  Basic business registration documents (like incorporation
                  certificate, partnership deed, GST registration), depending on
                  the business type.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm supports applicants through technical documentation and
              regulatory interactions, helping drug-related businesses stay
              aligned with licensing norms from day one.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Regulatory Expertise in Drug Licensing
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on license categories, applicable rules, and key
                  conditions relating to premises, storage, and qualified
                  personnel.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in preparing forms, affidavits, layouts, and
                  supporting records in the format generally expected by drug
                  control departments.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Compliance Management
                </h3>
                <p className="text-gray-700 text-sm">
                  Support across application, inspection, clarifications, and
                  renewal stages, providing a dependable partner for ongoing
                  compliance with drug licensing requirements.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
